export default __webpack_public_path__ + "static/media/warning-fill.bc148e76.svg";